import { config } from '../config';
import { getHeaders } from './getHeaders';

export const clearRooferSession = (token: string) =>
  fetch(`${config.apiBaseUrl}/api/v1/roofer/session`, {
    method: 'DELETE',
    headers: getHeaders(token),
  });
